"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Attachment = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var React = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
var responsive_1 = require("../utils/responsive");
var RenderAttachment = function (props) {
    var _a, _b;
    var _c = props.className, className = _c === void 0 ? "" : _c, fileName = props.fileName, intl = props.intl, label = props.label, theme = props.theme;
    var classNames = "gd-input-component gd-attachment-component " + className;
    var nameOfAttachment = responsive_1.isMobileView() ? "PDF" : fileName;
    var textFilters = intl.formatMessage({ id: "dialogs.schedule.email.attachment.filter" });
    return (React.createElement("div", { className: classNames },
        React.createElement("label", { className: "gd-label" }, label),
        React.createElement("span", { className: "gd-icon-pdf" },
            React.createElement(sdk_ui_kit_1.Icon.Pdf, { width: 11, height: 14, color: (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.complementary) === null || _b === void 0 ? void 0 : _b.c8 })),
        React.createElement("span", { className: "s-attachment-name" }, nameOfAttachment + " " + textFilters)));
};
exports.Attachment = react_intl_1.injectIntl(sdk_ui_theme_provider_1.withTheme(RenderAttachment));
//# sourceMappingURL=Attachment.js.map